import {
  IdIdentifier,
  TimeIdentifiers,
  UserIdentifier,
} from '../common/identifiers';

export enum Role {
  None = 'none',
  OuterAgent = 'outer-agent',
  InHouseAgent = 'in-house-agent',
  Risk = 'risk',
  Marketing = 'marketing',
  Payments = 'payments',
  Admin = 'admin',
  SuperUser = 'super-user',
  TradeTalkAdmin = 'trade-talk-admin',
  TradeTalkViewer = 'trade-talk-viewer',
}

export enum Ability {
  JumpHigh = 'jump-high', // Default :)))
  ViewPayments = 'view-payments',
  ViewAffiliates = 'view-affiliates',
  ManageAffiliates = 'manage-affiliates',
  ViewPayouts = 'view-payouts',
  ManagePayouts = 'manage-payouts',
  ViewUsers = 'view-users',
  ViewPrograms = 'view-programs',
  ViewCredits = 'view-credits',
  AddCredits = 'add-credits',
  ResendUserConfirmation = 'resend-user-confirmation',
  RequestKYC = 'request-kyc',
  ViewAccounts = 'view-accounts',
  EditAccountsEmail = 'edit-accounts-email',
  CreateAccounts = 'create-accounts',
  DeleteAccount = 'delete-accounts',
  ViewOrders = 'view-orders',
  ManageOrders = 'manage-orders',
  CreateAdminUsers = 'create-admin-users',
  ManagePartners = 'manage-partners',
  ManageSamples = 'manage-samples',
  ManagePrograms = 'manage-programs',
  ManageContests = 'manage-contests',
  ManageGroups = 'manage-groups',
  DeletePrograms = 'delete-programs',
  ManageUsers = 'manage-users',
  ManageAccounts = 'manage-accounts',
  ManageProfitableDays = 'manage-profitable-days',
  ManageEmailTemplates = 'manage-email-templates',
  ManagePaymentProviders = 'manage-payment-providers',
  ManageApplicationConfig = 'manage-applicaction-config',
  ManageAdminUsers = 'manage-admin-users',
  ManageRolesAbilities = 'manage-roles-abilitites',
  ImpersonateAccount = 'impersonate-account',
  ViewAddOns = 'view-add-ons',
  ManageAddOns = 'manage-add-ons',
  DeleteAddOns = 'delete-add-ons',
  ManageTradingSystem = 'manage-trading-system',
  CreatePendingAccounts = 'create-pending-accounts',
  DeletePendingAccounts = 'delete-pending-accounts',
  UpdateAccountExpireDate = 'update-account-expire-date',
  ViewSingle = 'view-single',
  DeletePositions = 'delete-positions',
  BlacklistUsers = 'blacklist-users',
  EditArticle = 'edit-article',
  ViewArticles = 'view-articles',
  ViewArticle = 'view-article',
  ViewPrizes = 'view-prizes',
  ManagePrizes = 'manage-prizes',
  ViewPositions = 'view-positions',
  UpdatePositions = 'update-positions',
  ViewContestAccounts = 'view-contest-accounts',
  ViewContests = 'view-contests',
  ViewUserActivities = 'view-user-activities',
  ClientPanel = 'client-panel',
  ViewRewards = 'view-rewards',
  SecurityCheck = 'security-check',
  ViewCfoDashboard = 'view-cfo-dashboard',
  EditUserProfile = 'edit-user-profile',
  ViewClientPanelPayoutTable = 'view-client-panel-payout-table',
  ManageAccountBalance = 'manage-account-balance',
}

export type AdminRole = IdIdentifier &
  TimeIdentifiers &
  UserIdentifier & {
    role: Role;
    abilities: Ability[];
  };

export const isUserAllowed = ({
  role,
  userAbilities,
  abilitiesRequired,
}: {
  role: Role;
  userAbilities: Ability[];
  abilitiesRequired: Ability[];
}) => {
  if (role === Role.SuperUser) {
    return true;
  }

  return userAbilities.some((ability) => abilitiesRequired.includes(ability));
};
